import sessionStore from '@/session/sessionStore'
import { commonSampleTypeService } from '@/api/services/common/sample-type/common-sample-type.service'
import { commonCaseTypeService } from '@/api/services/common/case-type/common-case-type.service'
import { keyBy, merge } from 'lodash'
import { GridUtils } from '@/shared/util/grid-utils'
import { StoreUtils } from '@/shared/util/store-utils'

export default {
    props: {
        sidebarStore: {}
    },
    data() {
        return {
            status: 'not_accepted',
            toggle: true,
            priorities: [],
            laboratories: [],
            sampleTypes: [],
            caseTypes: [],
            externalFilterModel: {},
            parentCheckboxesState: {
                prioritiesIndeterminate: false,
                allPrioritiesSelected: false,
                caseTypesIndeterminate: false,
                allCaseTypesSelected: false,
                sampleTypesIndeterminate: false,
                allSampleTypesSelected: false,
                laboratoriesIndeterminate: false,
                allLaboratoriesSelected: false
            }
        }
    },
    computed: {
    },
    methods: {
        selectAll(checked, elementsArray, changeHandler) {
            elementsArray.forEach((elem) => { elem.checked = checked })
            this.$forceUpdate()
            changeHandler()
        },
        priorityChangeHandler() {
            this.$nextTick(async () => {
                this.sidebarStore.state.externalFilterModel = null
                let elementsChecked = this.priorities.filter((elem) => elem.checked === true)
                this.parentCheckboxesState.prioritiesIndeterminate = elementsChecked.length > 0 && elementsChecked.length < this.priorities.length
                this.parentCheckboxesState.allPrioritiesSelected = elementsChecked.length === this.priorities.length
                this.externalFilterModel['priority.level'] =
                    elementsChecked.length
                        ? GridUtils.getSetFilterModel(elementsChecked.map((elem) => elem.level.toString()))
                        : null
                this.sidebarStore.state.externalFilterModel = this.externalFilterModel
                await this.saveConfig()
            })
        },
        caseTypeChangeHandler() {
            this.$nextTick(async () => {
                this.sidebarStore.state.externalFilterModel = null
                let elementsChecked = this.caseTypes.filter((elem) => elem.checked === true)
                this.parentCheckboxesState.caseTypesIndeterminate = elementsChecked.length > 0 && elementsChecked.length < this.caseTypes.length
                this.parentCheckboxesState.allCaseTypesSelected = elementsChecked.length === this.caseTypes.length
                this.externalFilterModel['caseType.id'] =
                    elementsChecked.length
                        ? GridUtils.getSetFilterModel(elementsChecked.map((elem) => elem.id.toString()))
                        : null
                this.sidebarStore.state.externalFilterModel = this.externalFilterModel
                await this.saveConfig()
            })
        },
        sampleTypeChangeHandler() {
            this.$nextTick(async () => {
                this.sidebarStore.state.externalFilterModel = null
                let elementsChecked = this.sampleTypes.filter((elem) => elem.checked === true)
                this.parentCheckboxesState.sampleTypesIndeterminate = elementsChecked.length > 0 && elementsChecked.length < this.sampleTypes.length
                this.parentCheckboxesState.allSampleTypesSelected = elementsChecked.length === this.sampleTypes.length
                this.externalFilterModel['samples.sampleType.id'] =
                    elementsChecked.length
                        ? GridUtils.getSetFilterModel(elementsChecked.map((elem) => elem.id.toString()))
                        : null
                this.sidebarStore.state.externalFilterModel = this.externalFilterModel
                await this.saveConfig()
            })
        },
        laboratoriesChangeHandler() {
            this.$nextTick(async () => {
                this.sidebarStore.state.externalFilterModel = null
                let elementsChecked = this.laboratories.filter((elem) => elem.checked === true)
                this.parentCheckboxesState.laboratoriesIndeterminate = elementsChecked.length > 0 && elementsChecked.length < this.laboratories.length
                this.parentCheckboxesState.allLaboratoriesSelected = elementsChecked.length === this.laboratories.length
                this.externalFilterModel['laboratory.labId'] =
                    elementsChecked.length
                        ? GridUtils.getSetFilterModel(elementsChecked.map((elem) => elem.labId.toString()))
                        : null
                this.sidebarStore.state.externalFilterModel = this.externalFilterModel
                await this.saveConfig()
            })
        },
        async saveConfig() {
            this.sidebarStore.state.checkboxesConfig = {
                externalFilterModel: this.externalFilterModel,
                laboratories: this.laboratories,
                priorities: this.priorities,
                caseTypes: this.caseTypes,
                sampleTypes: this.sampleTypes,
                parentCheckboxesState: this.parentCheckboxesState
            }
            await this.sidebarStore.saveConfig()
        }
    },
    async created() {
        this.priorities = sessionStore.state.priorities
        this.laboratories = StoreUtils.laboratories
        this.sampleTypes = await commonSampleTypeService.getSampleTypes()
        this.caseTypes = await commonCaseTypeService.getCaseTypes()

        await this.sidebarStore.loadConfig()
        if (this.sidebarStore.state.config.filterModel) {
            this.filterModel = this.sidebarStore.state.config.filterModel
            this.sidebarStore.setFilterModel(this.filterModel)
        } else {
            this.filterModel = {}
            this.sidebarStore.state.filterModel = null
        }
        if (this.sidebarStore.state.config.externalFilterModel) {
            this.externalFilterModel = this.sidebarStore.state.config.externalFilterModel
            this.sidebarStore.state.externalFilterModel = this.externalFilterModel
        } else {
            this.externalFilterModel = {}
            this.sidebarStore.state.externalFilterModel = null
        }

        if (this.sidebarStore.state.config.priorities) {
            this.priorities =
                Object.values(
                    merge(
                        keyBy(this.sidebarStore.state.config.priorities, 'id'),
                        keyBy(Object.values(this.priorities), 'id')))
        }
        if (this.sidebarStore.state.config.caseTypes) {
            this.caseTypes =
                Object.values(
                    merge(
                        keyBy(this.sidebarStore.state.config.caseTypes, 'id'),
                        keyBy(Object.values(this.caseTypes), 'id')))
        }
        if (this.sidebarStore.state.config.sampleTypes) {
            this.sampleTypes =
                Object.values(
                    merge(
                        keyBy(this.sidebarStore.state.config.sampleTypes, 'id'),
                        keyBy(Object.values(this.sampleTypes), 'id')))
        }
        if (this.sidebarStore.state.config.laboratories) {
            this.laboratories =
                Object.values(
                    merge(
                        keyBy(this.sidebarStore.state.config.laboratories, 'labId'),
                        keyBy(Object.values(this.laboratories), 'labId')))
        }
        if (this.sidebarStore.state.config.parentCheckboxesState) {
            this.parentCheckboxesState = this.sidebarStore.state.config.parentCheckboxesState
        }
        this.sidebarStore.state.config = {
            ...this.sidebarStore.getDefaultConfig(),
            ...this.sidebarStore.state.config
        }
    }
}
